import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import SmoothScroll from "./SmoothScroll";
import Analytics from "./Analytics";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen bg-creme text-brown relative">
            <Analytics />
            <SmoothScroll />
            <Header />
            <main className="relative overflow-x-hidden">{children}</main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}
